/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconReplacePatient/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaIconReplacePatient({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconReplacePatient",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 20,
  height = 20,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconReplacePatient.Svg"
  data-view-path={viewPath}
 viewBox="0 0 20 20"
 style={{'--as-1-ZvpTQh': alignSelf,'--mt-2-ZvpTQh': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-ZvpTQh': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-ZvpTQh': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-ZvpTQh': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-ZvpTQh': opacity,'--w-10-ZvpTQh': typeof width === 'number' ? `${width}px` : width,'--h-11-ZvpTQh': typeof height === 'number' ? `${height}px` : height,'--f-12-ZvpTQh': fill,'--a-7-ZvpTQh': isAnimated ? animation : "none",'--sd-8-ZvpTQh': isAnimated ? strokeDashoffset : 0,'--sd-9-ZvpTQh': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<g
  data-testid="TysiaIconReplacePatient.SvgGroup"
  data-view-path={viewPath}
 clipPath="url(#clip0_6073_9500)"
 className="views-block"
>
<path
  data-testid="TysiaIconReplacePatient.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M11 6a3 3 0 11-6 0 3 3 0 016 0zm3.91 4c.119 0 .233.047.316.13l1.643 1.644a.446.446 0 010 .631l-4.205 4.205a.447.447 0 01-.256.127l-1.901.259a.447.447 0 01-.503-.505l.268-1.902a.447.447 0 01.126-.253l4.197-4.205A.447.447 0 0114.91 10zM8 10c1.371 0 2.614.552 3.517 1.446l-2.004 2.008c-.26.26-.427.597-.479.961L8.882 15.5H3.5A.5.5 0 013 15a5 5 0 015-5z"
 style={{'--f-12-ZvpTQh': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</g>
</svg>
{children}
</React.Fragment>)
}